export class RequestsControllerService {

    private static instance: RequestsControllerService;

    private controllers: Map<string, AbortController[]> = new Map<string, AbortController[]>();

    private constructor() {

    }

    public static getInstance(): RequestsControllerService {
        if (!RequestsControllerService.instance) {
            RequestsControllerService.instance = new RequestsControllerService();
        }

        return RequestsControllerService.instance;
    }

    getControllers(plugins: string) {
        return this.controllers.get(plugins);
    }

    addController(plugins: string, controller: AbortController) {
        if (this.controllers.has(plugins)) {
            this.controllers.get(plugins)?.push(controller);
        } else {
            this.controllers.set(plugins, [controller]);
        }
    }

    removeController(plugins: string, controller: AbortController) {
        if (this.controllers.has(plugins)) {
            this.controllers.get(plugins)?.splice(this.controllers.get(plugins)?.indexOf(controller) as number, 1);
        }
    }

    clearControllers(plugins: string) {
        if (this.controllers.has(plugins)) {
            this.controllers.get(plugins)?.forEach((controller: AbortController) => {
                controller.abort();
            });
            this.controllers.set(plugins, []);
        }
    }

    clearAllControllers() {
        this.controllers.forEach((controllers: AbortController[], plugins: string) => {
            this.clearControllers(plugins);
        });
    }
}

